import { PartyDetailDto } from '@opb-workspace/shared';
import type { PartyRole } from './step2-party-actions.util';

/** Campos de formulario paso 2 alineados con `CreateShippingInstructionDto` (contacto / RUT). */
export function partyDetailToContactFormPatch(
    role: PartyRole,
    party: PartyDetailDto,
): Record<string, string | undefined> {
    switch (role) {
        case 'shipper':
            return {
                shipperEmail: party.email,
                shipperTaxIdentificationNumber: party.taxIdentificationNumber,
                shipperContactName: party.contactName,
                shipperPhoneNumber: party.phoneNumber,
                shipperMobilePhoneNumber: party.mobilePhoneNumber,
            };
        case 'consignee':
            return {
                consigneeEmail: party.email,
                consigneeTaxIdentificationNumber: party.taxIdentificationNumber,
                consigneeContactName: party.contactName,
                consigneePhoneNumber: party.phoneNumber,
                consigneeMobilePhoneNumber: party.mobilePhoneNumber,
            };
        case 'notify':
            return {
                notifyEmail: party.email,
                notifyTaxIdentificationNumber: party.taxIdentificationNumber,
                notifyContactName: party.contactName,
                notifyPhoneNumber: party.phoneNumber,
                notifyMobilePhoneNumber: party.mobilePhoneNumber,
            };
        default:
            return {};
    }
}
